/**
 * Competition page JavaScript.
 *
 * There are several widgets / objects that are defined before being used at the bottom of this script.
 * - CompetitionService, for entering the competition
 * - CompetitionEntryForm, competition entry page JS
 * - CompetitionQuestion, question competition specific JS
 * - CompetitionQuestionEntry, question entry competition specific JS
 *
 * @author Daniel Moffat
 */

const CompetitionEntryForm     = require("Scripts/gayl/competition-entry-form");
const CompetitionQuestion      = require("Scripts/gayl/competition-question");
const CompetitionQuestionEntry = require("Scripts/gayl/competition-question-entry");
const CompetitionService       = require("Scripts/gayl/competition-service");
const Poll                     = require("Scripts/gayl/poll");

module.exports = Competition;

function Competition() {

	var competitionType      = window.competition && competition.type; // Set globally on competition pages.
	var competitionService   = new CompetitionService();
	var competitionEntryForm = new CompetitionEntryForm(competitionService);

	if(competitionType === "QUESTION_ENTRY") {
		// Shouldn't need to do this ($(function() { ... }), but there's a weird race condition when you try and show a modal on page load. Something to do with OwlCarousel...
		$(function() {
			new CompetitionQuestionEntry(competitionService);
		});
	}

	if(competitionType === "QUESTION") {
		new CompetitionQuestion();
		new Poll();
	}
}